import classNames from 'classnames'
import { AnimatePresence, motion, type Transition } from 'framer-motion'
import React, { PropsWithChildren } from 'react'

import styles from './Expandable.module.scss'

interface ExpandableProps extends PropsWithChildren {
  isExpanded: boolean
  fullWidth?: boolean
}

export const Expandable: React.FC<ExpandableProps> = ({ isExpanded, children, fullWidth }) => {
  const transition: Transition = { duration: 0.3, ease: [0.4, 0, 0.2, 1] }

  return (
    <AnimatePresence initial={false}>
      {isExpanded && (
        <motion.div
          initial={{ height: 0, opacity: 0, overflow: 'hidden' }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className={classNames({ [styles.fullWidth]: fullWidth })}
          transition={transition}
        >
          <div style={{ paddingTop: '0.1px', marginTop: '-0.1px' }}>{children}</div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
